import { EChartsOption, LineSeriesOption } from "echarts";
import { generateNumbers } from "@/utils/math";
import icc线控转向 from "@/assets/img/icc线控转向.png";
import icc后轮转向 from "@/assets/img/icc后轮转向.png";
export type PlayStatus = "play" | "pause" | "stop";
export const getDefaultSeriesData = () => {
  const res = {
    UIRx_ACUYawRate_open: [],
    UIRx_ACUYawRate_off: [],
    UIRx_SBW_HWAAng_open: [],
    UIRx_SBW_HWAAng_off: [],
    // 实际横摆速度
    UIRx_ACUYawRate: [],
    // 前轮角度
    UIRx_AxleStAng_FA: [],
    // 后轮角度
    UIRx_AxleStAng_RA: [],
    // 前轮转向比
    UIRx_FrontGearRto: [],
    // 原始横摆速度
    UIRx_OrgYawRate: [],
    // 后轮转向比
    UIRx_RearGearRto: [],
    // 方向盘角度
    UIRx_SBW_HWAAng: [],
    // 车速
    UIRx_VehSpd: [],
  } as DomianControl.DSTSeriesData;
  return res;
};
export const optionseries1 = () => [
  {
    id: "UIRx_ACUYawRate_open",
    name: "功能开启",
    color: "#ffc101",
  },
  {
    id: "UIRx_ACUYawRate_off",
    name: "功能关闭",
    color: "#C10015",
  },
];
export const optionseries2 = () => [
  {
    id: "UIRx_AxleStAng_RA",
    name: "ABS标志位",
    color: "#32CD32",
  },
];
export const optionseries3 = () => [
  {
    id: "UIRx_ACUYawRate",
    name: "前轮转角",
    color: "#0372bf",
  },
  {
    id: "UIRx_OrgYawRate",
    name: "后轮转角",
    color: "#C10015",
  },
];
export const getDefaultSelections = () => [
  {
    icon: "img:" + icc线控转向,
    // img:  icc线控转向,
    value: true,
    name: "UITx_ActuatorEna_SbW",
    label: "SBW",
    disable: true,
  },
  {
    icon: "img:" + icc后轮转向,
    // img:  icc后轮转向,
    value: true,
    name: "UITx_ActuatorEna_Rws",
    label: "RWS",
  },
];
export const getTitle3 = ($q: any) =>
  ({
    top: -2,
    left: 15,
    // bottom:10,
    textStyle: {
      color: $q.dark.isActive ? "#bdbdbd" : "#032f2b",
      fontSize: 14,
    },
  } as EChartsOption["title"]);
export const decreasingSequence = generateNumbers(10);
export const getDefaultSeriesProp = () =>
  ({
    type: "line",
    showSymbol: false,
    symbol: "circle",
    symbolSize: 6,
    lineStyle: {
      width: 2,
    },
    clip: true,
    data: [],
  } as LineSeriesOption);
export const getChartsDefaultOptions = (index: number) => {
  let seriesList =
    [optionseries1(), optionseries2(), optionseries3()][index] ||
    optionseries1();
  const xAxisDate = generateNumbers(20).reverse();
  const max = [20, 0, 5][index];
  const min = [-20, 3, -5][index];

  seriesList = seriesList?.map((item: any) => ({
    ...getDefaultSeriesProp(),
    ...item,
  }));
  const lineColor = "rgba(199, 237, 250,0.2)";
  const interval = (index: number, value: string) => {
    // 判断 value 是整数
    return Number.isInteger(Number(value)) ? value : "";
  };
  return {
    backgroundColor: "#d4dbdf",
    animation: false,
    //   legend: {
    //     show: true,
    //     // x: "4%",
    //     top: "20px",
    //     data: ["123"],
    //     // type: "scroll",
    //     textStyle: {
    //       color: "#cccccc",
    //       fontWeight: 700,
    //       fontSize: 12,
    //     },
    //     formatter: function (name) {
    //       return name;
    //     },
    //   },
    legend: {
      show: true,
      // type: 'scroll',
      // orient: 'vertical',
      // right: 20,
      // top: "10%",
      // bottom: 20,
    },
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "cross",
        label: {
          backgroundColor: "#283b56",
        },
      },
    },
    grid: {
      top: 30,
      left: 50,
      right: 50,
      bottom: 30,
    },
    xAxis: {
      name: "sec",
      data: xAxisDate,
      nameTextStyle: {
        color: "#fff",
      },
      // nameGap: -30,
      // minorTick: {
      //   show: true,
      // },
      // minorSplitLine: {
      //   show: true,
      //   lineStyle: {
      //     color: lineColor,
      //   },
      // },
      axisPointer: {
        snap: true,
        lineStyle: {
          color: "#8e96a1",
          width: 2,
        },
        label: {
          show: false,
          // formatter: function (params) {
          //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
          // },
          backgroundColor: "#d4dbdf",
        },
        handle: {
          show: true,
          color: "#d4dbdf",
          size: 30,
          margin: 10,
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          shadowBlur: 0,
        },
      },
      splitLine: {
        show: true,
        interval: (index: number, value: string) => {
          return Number.isInteger(Number(value));
        },
        lineStyle: {
          color: lineColor,
        },
      },
      axisLabel: {
        show: index === 2 ? true : false, // 隐藏 x 轴标签
        interval,
        // formatter: (number: string) => {
        //   console.log("[BOWEN_LOG] 🚀 ~~ getChartsDefaultOptions ~~ number:", number);
        //   return Number(number) % 5 === 0 || Number(number) === 1 ? number : "";
        // },
      },
      axisTick: {
        interval,
      },
      axisLine: {
        onZero: false,
        lineStyle: {
          color: lineColor,
        },
      },
    },
    yAxis: {
      type: "value",
      max,
      min,
      interval: index === 1 ? 1 : undefined, // 当 index 为 1 时，设置 interval 为 1
      minorSplitLine: {
        show: true,
        lineStyle: {
          color: lineColor,
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: lineColor,
        },
      },
      axisLine: {
        lineStyle: {
          color: lineColor,
        },
      },
      // axisLabel: {
      //   formatter: (value: number) => {
      //     if (index === 1) {
      //       return Math.round(value); // 当 index 为 1 时，显示整数
      //     }
      //     return value; // 其他情况下，显示原始值
      //   },
      // },
      // axisPointer: {
      //   type: "line",
      //   snap: true,
      //   show: true,
      //   label: {
      //     show: false,
      //     // formatter: function (params) {
      //     //   return echarts.format.formatTime('yyyy-MM-dd', params.value);
      //     // },
      //     backgroundColor: "#8e96a1",
      //   },
      // },
    },
    dataZoom: [
      {
        show: true,
        type: "inside",
        filterMode: "none",
      },
    ],
    series: seriesList,
  } as EChartsOption;
};
